const API_URL =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3000/api'
    : 'https://api.amco.pt/api';

// Helper para logging consistente
function log(...args) {
  console.log('%c[RGPD SERVICE]', 'color:#0C92AF;font-weight:bold;', ...args);
}

// 🔹 1. Inicializa link
export async function getInitLink(token) {
  const url = `${API_URL}/rgpd/${token}/`;
  log('➡️ GET INIT', url);
  const res = await fetch(url);
  log('⬅️ STATUS:', res.status, 'TYPE:', res.headers.get('content-type'));
  const data = await res.json().catch(() => null);
  log('⬅️ BODY:', data);
  if (!res.ok) throw new Error('Erro ao obter link inicial');
  return data;
}

// 🔹 2. Valida últimos 3 dígitos e envia OTP
export async function validatePhone(token, lastDigits) {
  const url = `${API_URL}/rgpd/${token}/validate-phone`;
  log('➡️ POST VALIDATE-PHONE', url, { lastDigits });
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ lastDigits }),
  });
  log('⬅️ STATUS:', res.status, 'TYPE:', res.headers.get('content-type'));
  const data = await res.json().catch(() => null);
  log('⬅️ BODY:', data);
  if (!res.ok) throw new Error('Erro ao validar telefone');
  return data;
}

// 🔹 3. Valida OTP e cria sessão
export async function validateOtp(token, otp) {
  const url = `${API_URL}/rgpd/${token}/validate-otp`;
  log('➡️ POST VALIDATE-OTP', url, { otp });
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ otp }),
  });
  log('⬅️ STATUS:', res.status, 'TYPE:', res.headers.get('content-type'));
  const data = await res.json().catch(() => null);
  log('⬅️ BODY:', data);
  if (!res.ok) throw new Error('Erro OTP');
  return data;
}

// 🔹 4. Obter PDF
export async function getPdf(token) {
  const res = await fetch(`${API_URL}/rgpd/${token}/pdf`, {
    method: 'GET',
    headers: { Accept: 'application/pdf' },
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Erro ao obter PDF (${res.status}): ${text}`);
  }

  const blob = await res.blob();
  return { data: blob };
}

// 🔹 5. Assinar RGPD
export async function signRgpd(token) {
  const res = await fetch(`${API_URL}/rgpd/${token}/sign`, {
    method: 'POST',
  });
  if (!res.ok) throw new Error('Erro ao assinar RGPD');
  return await res.json();
}

export async function resendOtp(token) {
  const res = await fetch(`${API_URL}/rgpd/${token}/resend-otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) throw new Error('Erro ao reenviar OTP');
  return await res.json();
}